<!-- eslint-disable vue/no-v-html -->
<script lang="ts">
import type { SetupContext } from 'vue';
import type { HekateDisplayField } from '@onshape/www-inertia';
import CoordinatorProvider from '../coordinator/CoordinatorProvider';
import FieldErrorMessage from './FieldErrorMessage.vue';

export default defineComponent({
  components: {
    FieldErrorMessage,
  },
  props: {
    field: {
      required: true,
      type: Object as unknown as () => HekateDisplayField,
    },
    modelValue: {
      required: true,
      type: String,
    },
  },
  emits: ['blur', 'focus', 'update:modelValue'],
  setup(props: { modelValue: string; field: HekateDisplayField }, context: SetupContext) {
    const { field, modelValue } = toRefs(props);
    return CoordinatorProvider.get().textInputField({
      field,
      modelValue,
      context,
    });
  },
});
</script>

<template>
  <div class="field-text-input field-container">
    <div
      :class="{
        'field-content': true,
        'field-content-is-validated': field.isValidated,
        'field-content-is-errored': field.errorMessages.length > 0,
      }"
    >
      <label
        v-if="!placeholder"
        :for="field.htmlName"
      >
        <span v-html="$t(field.name, field.htmlName, field.label)" /><sup
          v-if="field.isRequired"
          class="required-indicator"
          title="This field is required"
          >*</sup
        >
      </label>
      <input
        :id="field.htmlName"
        v-model="bubbleModel"
        :type="inputType"
        :placeholder="placeholder"
        :html-name="field.htmlName"
        :required="field.isRequired"
        :disabled="field.isDisabled"
        :autocomplete="field.autocomplete"
        @blur="$emit('blur', field)"
        @focus="$emit('focus', field)"
      />
      <field-error-message :messages="field.errorMessages" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.field-text-input {
  width: 100%;

  ::placeholder {
    text-align: center;
  }
}
.field-content:has([for^='addEmail']) {
  width: 90%;
  margin-left: auto;
}
</style>
